import { gql, useMutation } from "@apollo/client";

const MUTATION = gql`
  mutation FollowUser($innerCircle: Boolean, $userId: ID!) {
    followUser(innerCircle: $innerCircle, userId: $userId) {
      success
    }
  }
`;

interface DataType {
  followUser: {
    success: boolean;
  };
}

interface VariablesType {
  innerCircle?: boolean;
  userId: string;
}

export default function useFollowUser() {
  return useMutation<DataType, VariablesType>(MUTATION);
}
